import React from 'react';
import styled, { keyframes } from 'styled-components';

const SkeletonAnimation = keyframes`
  0% { transform: translateX(-100%) }
 100% { transform: translateX(100%) }
`;

const ScheduleSkeletonContainer = styled.div`
  ${p => p.width ? `width: ${p.width}` : "width: 100%"};
  ${p => p.height ? `height: ${p.height}` : "height: 44px"};
  ${p => p.borderRadius ? `border-radius: ${p.borderRadius}` : ""};
  position: relative;
  overflow: hidden;
  background-color: #dee2e6;
  
  &:after{    
    content: "";
    animation: ${SkeletonAnimation} 1.2s infinite;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
  }
`

const ScheduleSkeleton = ({width, height, borderRadius}) => {
    return (
        <ScheduleSkeletonContainer width={width} height={height} borderRadius={borderRadius}></ScheduleSkeletonContainer>
    )
}

export default ScheduleSkeleton;